import { useAccountPaymentPlanQuery, useAccountQuery, useAccountStorageQuery, useContractNumberQuery, useUpdateAccountMutation, } from 'api/generated';
import { getBaseOptions } from 'api/wrappers';
import { getDateFromApiString } from 'utils/date';
export const useAccountNotesQueryApi = (variables) => {
    const { data, ...rest } = useAccountQuery(getBaseOptions(variables));
    const notes = data?.account?.notes ?? '';
    return { ...rest, data: notes };
};
export const useAccountQueryApi = (variables) => {
    const { data, ...rest } = useAccountQuery(getBaseOptions(variables));
    return { ...rest, data: data?.account };
};
export const useAccountStorageQueryApi = (variables, options) => {
    const { data, ...rest } = useAccountStorageQuery(getBaseOptions(variables, options));
    return { ...rest, data: data?.account?.storage };
};
export const useUpdateAccountNotesMutation = useUpdateAccountMutation;
export const getAccountNotesMutationOptions = (id, notes) => ({
    variables: {
        account: {
            id,
            notes,
        },
    },
});
export const useContractNumberQueryApi = (variables) => {
    const { data, ...rest } = useContractNumberQuery(getBaseOptions(variables));
    return { ...rest, data: data?.account?.contractNumber };
};
export const useAccountPaymentPlanQueryApi = (variables, options) => {
    const { data, ...rest } = useAccountPaymentPlanQuery(getBaseOptions(variables, options));
    const { activeSubscription } = data?.account ?? {};
    if (!activeSubscription) {
        return { ...rest, data: undefined };
    }
    return {
        ...rest,
        data: {
            ...activeSubscription,
            endDate: activeSubscription.endDate
                ? getDateFromApiString(activeSubscription.endDate)
                : undefined,
        },
    };
};
export { useCancelTerminationMutation } from 'api/generated';
export const getTerminationMutationOptions = (id) => ({
    variables: {
        accountId: id,
    },
});
